import React, { useState, useEffect } from "react";
import { HiOutlineInformationCircle } from "react-icons/hi";
import Tooltip from "../../Atoms/Tooltip";

const InputTags = ({
  placeholder,
  label,
  mandatory,
  tooltipText,
  disabled = false,
  value = [],
  onChange,
  tagKey = "name",
  tagIdKey = "id",
}) => {
  const inputTagsStyles = {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      padding: "10px",
      borderRadius: "6px",
    },
    label: {
      fontSize: "14px",
      color: "#e1e1e1",
      fontWeight: "400",
      marginRight: '5px'
    },
    tagsContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px",
      padding: "10px",
      border: "1px solid #314158",
      borderRadius: "6px",
      backgroundColor: "transparent",
      minHeight: "48px",
      alignItems: "center",
    },
    tag: {
      display: "flex",
      alignItems: "center",
      backgroundColor: "#314158",
      color: "#fff",
      padding: "4px 8px",
      borderRadius: "6px",
      fontSize: "14px",
    },
    closeBtn: {
      marginLeft: "6px",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "16px",
      lineHeight: "1",
    },
    input: {
      border: "none",
      outline: "none",
      flex: 1,
      fontSize: "14px",
      backgroundColor: "transparent",
      color: "#fff",
    },
  };

  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState(value || []);

  useEffect(() => {
    setTags(value || []);
  }, [value]);

  // Helper function to get display text from tag (handles both strings and objects)
  const getTagDisplayText = (tag) => {
    if (typeof tag === 'string') return tag;
    if (typeof tag === 'object' && tag !== null) return tag[tagKey] || tag.name || tag.title || JSON.stringify(tag);
    return String(tag);
  };

  // Helper function to get tag ID (handles both strings and objects)
  const getTagId = (tag) => {
    if (typeof tag === 'string') return tag;
    if (typeof tag === 'object' && tag !== null) return tag[tagIdKey] || tag.id || tag.name || tag.title;
    return String(tag);
  };

  // Helper function to check if tag already exists
  const tagExists = (newTagText) => {
    return tags.some(tag => getTagDisplayText(tag) === newTagText);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const newTagText = inputValue.trim();
      if (newTagText && !tagExists(newTagText)) {
        // Create new tag object with the same structure as existing tags
        let newTag;
        if (tags.length > 0 && typeof tags[0] === 'object') {
          // If existing tags are objects, create a new object
          newTag = { [tagIdKey]: Date.now().toString(), [tagKey]: newTagText };
        } else {
          // If existing tags are strings, create a string
          newTag = newTagText;
        }
        
        const newTags = [...tags, newTag];
        setTags(newTags);
        if (onChange) onChange(newTags);
      }
      setInputValue("");
    }
  };

  const removeTag = (tagToRemove) => {
    const newTags = tags.filter((tag) => getTagId(tag) !== getTagId(tagToRemove));
    setTags(newTags);
    if (onChange) onChange(newTags);
  };

  return (
    <div style={inputTagsStyles.container}>
      <div className="d-flex flex-row">
        {label && (<label style={inputTagsStyles.label}>{mandatory ? label + " *" : label}</label>)}

        {(tooltipText !== "" && tooltipText !== undefined) && (
            <Tooltip text={tooltipText}>
              <HiOutlineInformationCircle color="#C27AFF" />
            </Tooltip>
        )}
      </div>
      <div style={inputTagsStyles.tagsContainer}>
        {tags.map((tag, index) => (
          <div key={getTagId(tag) || index} style={inputTagsStyles.tag}>
            {getTagDisplayText(tag)}
            <span style={inputTagsStyles.closeBtn} onClick={() => removeTag(tag)}>×</span>
          </div>
        ))}
        <input
          style={inputTagsStyles.input}
          type="text"
          placeholder={placeholder || "Type and press Enter..."}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default InputTags;